import { decryptData } from "./helpers";

export const permissionsMiddleWare = route => {
  let isAccess = false;
  const decryptUserData = decryptData(
    localStorage.getItem("userPermissions"),
    process.env.VUE_APP_SECRET_KEY
  );
  const user = decryptData(
    localStorage.getItem("userInfo"),
    process.env.VUE_APP_SECRET_KEY
  );

  const userRole = user.userRole.map(item => item.name)[0];

  if (decryptUserData) {
    const permissionsDto = decryptUserData.permissions;
    Object.values(permissionsDto).forEach(item => {
      Object.values(item).filter(e => {
        if (e.routeName === route) {
          if (userRole === "admin") {
            isAccess = true;
          } else {
            isAccess = e.permissions[userRole];
          }
        }
      });
    });
  } else {
    isAccess = true;
  }
  return isAccess;
};

export const checkModulePermission = moduleName => {
  let isAccess = [];
  const decryptUserData = decryptData(
    localStorage.getItem("userPermissions"),
    process.env.VUE_APP_SECRET_KEY
  );
  const user = decryptData(
    localStorage.getItem("userInfo"),
    process.env.VUE_APP_SECRET_KEY
  );

  const userRole = user?.userRole?.map(item => item.name)[0];

  const permissions = decryptUserData?.module_permissions?.module_permissions;
  if (user?.full_name !== "ady_Uc") {
    const accessible = permissions?.filter(
      obj => obj.moduleName == moduleName
    )[0]?.permissions[userRole];
    isAccess = !accessible;
  } else {
    isAccess = !true;
  }
  return isAccess;
};
